const styles = () => ({
  root: {
    '& .MuiInputBase-input': {
      textAlign: 'center',
    }
  },
})

export default styles
